import { last } from 'lodash';
import { components, OptionProps } from 'react-select';

import CaseStatusSticker from 'dashboard/components/CaseStatusSticker';
import { OptionType } from 'dashboard/components/ReactSelect';
import { CaseStateColor } from 'dashboard/models/case-template';

export interface CaseStatusOptionType extends OptionType {
  label: string;
  backgroundColor: CaseStateColor;
}

const CaseStatusOption = (props: OptionProps<CaseStatusOptionType>) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const index = last(props.innerProps.id.split('-'));
  const id = props.selectProps.id != null ? `${props.selectProps.id}_${index}` : undefined;

  return (
    <components.Option {...props} innerProps={{ ...props.innerProps, id }}>
      <CaseStatusSticker
        caseState={{ name: props.data.label, color: props.data.backgroundColor }}
        disabled={props.data.disabled}
      />
    </components.Option>
  );
};

export default CaseStatusOption;
